import { ApolloLink } from "@apollo/client";
import { createLogger, ILogger } from "@/infrastructure/services/logger";
import { map } from "rxjs";
import { FormattedExecutionResult } from "graphql";

const logger: ILogger = createLogger("GraphQLInterceptorLink");

export const graphQlInterceptorLink = new ApolloLink((operation, forward) => {
  const startTime = Date.now();

  return forward(operation).pipe(
    map((response: FormattedExecutionResult<Record<string, any>, Record<string, any>>) => {
      const duration = Date.now() - startTime;

      if (duration > 6000) {
        logger.warn(`GraphQL operation ${operation.operationName} took ${duration}ms`, {
          operation,
          duration,
        });
      }

      return response;
    })
  );
});
